import React from 'react';
import validator from 'validator';
import PropTypes from "prop-types";
import {getFormInputCssClass, hasMessage, setupOnExtractData} from "../../../util/FormUtil";
import {fetchResponseHandler, fetchPost} from "../../../util/FetchUtil";
import {isNotBlank} from "../../../util/StringUtil";
import VerifyEmailComponent from "../verifyemail/VerifyEmailComponent";
import UserDataService from "../../common/UserDataService";
import Drawer from "../../../util/Drawer";


export const PROP_NAME_EMAIL = "email";
const PROP_NAME_CONFIRM_EMAIL = "confirmEmail";
const emailPatternFailMessage = "A valid email address is required to complete registration";
const confirmEmailMatchesFailMessage = "Email does not match with confirm email";

class EmailInputComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.emailChange = this.emailChange.bind(this);
        this.emailValidation = this.emailValidation.bind(this);
        this.confirmEmailChange = this.confirmEmailChange.bind(this);
        this.extractData = this.extractData.bind(this);
        this.checkIsEmailUsedAndInactive = this.checkIsEmailUsedAndInactive.bind(this);
        this.sendVerificationEmail = this.sendVerificationEmail.bind(this);
        this.setShowVerifyEmailDrawer = this.setShowVerifyEmailDrawer.bind(this);
        this.showVerifyEmailDrawer = this.showVerifyEmailDrawer.bind(this);
        this.hideVerifyEmailDrawer = this.hideVerifyEmailDrawer.bind(this);

        const {inRegistration} = this.props;
        this.emailUsedError =
            <div className={"grid"}>
                <div className={"grid__col-lg-10 grid__col-xs-12 hard"}>This email has already been registered but your account is pending. Please verify your email using the link we sent to your inbox.</div>
                <div className={"grid__col-lg-2 grid__col-xs-12 hard"}><a onClick={this.showVerifyEmailDrawer} className="btn btn--outline push--right drawer-verify-email-button">Resend verification email</a></div>
            </div>;
        this.emailDisabledError =
            <div>
                Please contact Enterprise Application & System Entitlements at +1 312 456 1560 (US), +44 20 3379 3802 (Europe), +65 6593 5536 (Asia)  to complete your {inRegistration ? " registration." : " update."}
            </div>;
    }

    setShowVerifyEmailDrawer(showVerifyEmailDrawer){
        this.setState(state => ({...state, showVerifyEmailDrawer}));
    }

    showVerifyEmailDrawer(){
        this.setShowVerifyEmailDrawer(true);
    }

    hideVerifyEmailDrawer(){
        this.setShowVerifyEmailDrawer(false);
    }

    componentDidMount() {
        const {setFormState, metadata, data, inRegistration} = this.props;

        const keys = [PROP_NAME_EMAIL];
        for (let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (! metadata[key]){
                setFormState({property: key, data: data[key] ? data[key] : "", metadata: {dirty: false, valid: isNotBlank(data[key])}});
            }
        }

        if(data[PROP_NAME_EMAIL]){
            setFormState({property: PROP_NAME_EMAIL, metadata: {initialEmail: data[PROP_NAME_EMAIL]}});
            if(inRegistration)
                this.emailValidation(data[PROP_NAME_EMAIL]);
        }

        setupOnExtractData(this);
    }

    extractData(){
        let {data} = this.props;
        let result = {
            email: data[PROP_NAME_EMAIL]
        };

        return result;
    };

    emailValidation(email){
        const {setFormState, data, findCalcs, userDataInit, userDataService, metadata} = this.props;
        let isValid = false;
        let isDirty = false;
        let message = null;

        const emailPattern = userDataInit[PROP_NAME_EMAIL].emailPattern;
        const emailMaxLength = userDataInit[PROP_NAME_EMAIL].maxEmailLength;

        if(email && email.trim().length > 0){
            isDirty = true;
            if (emailPattern.test(email) && validator.isEmail(email)) {   // Check Pattern
                if (emailMaxLength >= (email.trim().length)) {    // check Length
                    isValid = true;
                } else {
                    message = "Email length must not exceed the length of " + emailMaxLength + "  characters";
                }
            }else{
                message = emailPatternFailMessage;
            }
        }
        setFormState({property: PROP_NAME_EMAIL, data: email, metadata: {dirty: isDirty, valid: isValid, message: message}});
    }

    emailChange(e){
        const {setFormState, data, findCalcs, userDataInit, userDataService, metadata} = this.props;
        const email = e.target.value;
        let isValid = false;
        let isDirty = false;
        let message = null;

        const emailPattern = userDataInit[PROP_NAME_EMAIL].emailPattern;
        const emailMaxLength = userDataInit[PROP_NAME_EMAIL].maxEmailLength;

        if(email && email.trim().length > 0){
            isDirty = metadata[PROP_NAME_EMAIL].initialEmail ? !(metadata[PROP_NAME_EMAIL].initialEmail === email) : true;
            if (emailPattern.test(email) && validator.isEmail(email)) {   // Check Pattern
                if (emailMaxLength >= (email.trim().length)) {    // check Length
                    isValid = true;
                } else {
                    message = "Email length must not exceed the length of " + emailMaxLength + "  characters";
                }
            }else{
                message = emailPatternFailMessage;
            }
        }
        setFormState({property: PROP_NAME_EMAIL, data: email, metadata: {dirty: isDirty, valid: isValid, message: message}});
        findCalcs(null, PROP_NAME_EMAIL, email);
        this.confirmEmailChange(null, email);
    }

    confirmEmailChange(e, newEmail){
        const {setFormState, data, metadata, inRegistration} = this.props;
        const confirmEmail = e ? e.target.value : data[PROP_NAME_CONFIRM_EMAIL];
        const email = newEmail ? newEmail : data[PROP_NAME_EMAIL];
        let isValid = false;
        let isDirty = false;
        let message = null;

        if(confirmEmail && confirmEmail.trim().length > 0){
            isDirty = true;
            if (email.toUpperCase() === confirmEmail.toUpperCase()) {
                isValid = true;
            }else{
                message = confirmEmailMatchesFailMessage;
            }
        }

        if(!inRegistration && metadata[PROP_NAME_EMAIL].initialEmail === email){
            isValid = true;
        }

        //Since confirm email change is triggered by email change, we can check email value here to cover both bases
        if(email && email.length > 0){
            this.checkIsEmailUsedAndInactive(email);
        }

        setFormState({property: PROP_NAME_CONFIRM_EMAIL, data: confirmEmail, metadata: {dirty: isDirty, valid: isValid, message: message}});
    }

    checkIsEmailUsedAndInactive(email){
        const {userDataService, setFormState, setPageError} = this.props;
        userDataService.isEmailUsedAndInactive(email)
            .then(fetchResponseHandler)
            .then(resp => {
               if(resp.inactive || resp.disabled){
                   let error = resp.disabled ? this.emailDisabledError : this.emailUsedError;
                   setPageError(error);
                   setFormState({property: PROP_NAME_EMAIL, data: email, metadata: {dirty: true, valid: false, message: error}});
               }else{
                   setPageError(null);
               }
            });
    }

    sendVerificationEmail(obj = {}){
        const {userDataService} =  this.props;
        return fetchPost({
            path: userDataService.contextRoot + "/register/sendVerificationEmail.action",
            body: JSON.stringify(obj)
        });
    }

    render() {
        const {data, isEditable = true, userDataInit, metadata, hideConfirmEmail, inRegistration} = this.props;
        const {showVerifyEmailDrawer} = this.state;
        let hasInputClassEmail = getFormInputCssClass(metadata, PROP_NAME_EMAIL);
        let hasInputClassConfirmEmail = getFormInputCssClass(metadata, PROP_NAME_CONFIRM_EMAIL);
        let activationEmailOption = {
            oldEmail: data[PROP_NAME_EMAIL],
            email: data[PROP_NAME_EMAIL],
            app: null,
            originalRequest: null,
            targetDescription: null
        };

        return (
            <div className={"grid form-fields"}>
                <div className="grid__col-md-6 grid__col-sm-12">
                    <label htmlFor={PROP_NAME_EMAIL}>Email</label>
                    <input id={PROP_NAME_EMAIL}
                           style={{maxHeight:'28px'}}
                           className={"text-input text-input--large" + hasInputClassEmail}
                           maxLength={userDataInit[PROP_NAME_EMAIL].maxEmailLength}
                           value={data[PROP_NAME_EMAIL]}
                           onChange={this.emailChange}
                           disabled={ !isEditable ? "disabled" : null}
                    />
                    {
                        hasMessage(metadata, PROP_NAME_EMAIL) && metadata[PROP_NAME_EMAIL].message != this.emailUsedError &&
                        metadata[PROP_NAME_EMAIL].message != this.emailDisabledError &&
                        <div className="error display--block">{metadata[PROP_NAME_EMAIL].message}</div>
                    }
                </div>
                <div className={"grid__col-md-6 grid__col-sm-12"}>
                    {
                                                //Email ((doesnt exist or isEmpty) or (email metadata exists and is dirty)) and not hideConfirmEmail
                        (!hideConfirmEmail &&
                            ((!data[PROP_NAME_EMAIL] || data[PROP_NAME_EMAIL] == "") ||
                                (metadata[PROP_NAME_EMAIL] && metadata[PROP_NAME_EMAIL].dirty) ||
                                /*(inRegistration && data[PROP_NAME_EMAIL] && !metadata[PROP_NAME_EMAIL]) ||*/
                                (inRegistration && data[PROP_NAME_EMAIL] && metadata[PROP_NAME_EMAIL] && metadata[PROP_NAME_EMAIL].initialEmail)
                            )) &&
                        <div>
                            <label htmlFor={PROP_NAME_CONFIRM_EMAIL}>Confirm Email</label>
                            <input id={PROP_NAME_CONFIRM_EMAIL}
                                   style={{maxHeight: '28px'}}
                                   className={"text-input text-input--large" + hasInputClassConfirmEmail}
                                   maxLength={userDataInit[PROP_NAME_EMAIL].maxEmailLength}
                                   value={data[PROP_NAME_CONFIRM_EMAIL]}
                                   onChange={this.confirmEmailChange}
                                   disabled={ !isEditable ? "disabled" : null}
                            />
                            {
                                hasMessage(metadata, PROP_NAME_CONFIRM_EMAIL) &&
                                <div className="error display--block">{metadata[PROP_NAME_CONFIRM_EMAIL].message}</div>
                            }
                        </div>
                    }
                    <Drawer onClose={this.hideVerifyEmailDrawer} show={showVerifyEmailDrawer} footer={
                        <button type="button" className="btn" onClick={this.hideVerifyEmailDrawer}>Close</button>
                    }>
                        <div className={"push--top"}>
                            <VerifyEmailComponent
                                sendVerificationEmailFunction={this.sendVerificationEmail}
                                allowEmailUpdate={false}
                                sendOnMount={true}
                                activationEmailOption={activationEmailOption}
                            />
                        </div>
                    </Drawer>
                </div>
            </div>
        );
    }
}

EmailInputComponent.propTypes = {
    // This is the object that contains properties like country, address, etc
    data: PropTypes.object.isRequired,
    isEditable: PropTypes.bool,
    metadata: PropTypes.object.isRequired,

    // This is the function to set properties of the "data" object. The function should take property name as first parameter and the value as the second parameter.
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    findCalcs: PropTypes.func.isRequired,
    onExtractData: PropTypes.func.isRequired,
    userDataService: PropTypes.instanceOf(UserDataService).isRequired,
    setPageError: PropTypes.func.isRequired,

    inRegistration: PropTypes.bool
}

export default EmailInputComponent;

